{
  "name": "continuous-integration",
  "hostname": "ci.serveport.com",
  "development": true,
  "production": false,
  "applicationName": "ServePort",
  "sourceVersion": "e55d2d228be24af690857f2784983cc47f24a51c",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.ci.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.ci.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.ci.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.ci.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-ci.auth0.com",
    "clientId": "HkeWLNJawgqfvTAiTFecz47pX0nq0WRM",
    "useLocalStorageCache": true
  },
  "auth": {
    "inactivityTimeout": 15,
    "inactivityWarning": 2
  },
  "statusApp": {
    "apiRootUrl": "https://@.ci.serveport.com/_api/maintenance/",
    "code": "_otSSDT9qMnGUM_kQKRl_NtGP_X0QjQfP2MT36jevuGnAzFuuPbGmA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {},
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "922a8891-8e01-45d9-867a-b1d29f57cd2e"
    },
    "appInsights": {
      "instrumentationKey": "9a6eabd7-934d-4e84-90a9-d8ab7fd0c5d9"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 25,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z7V2-XIA84H-5B4B5R-0U483J-2E5P0D-6E2L5X-3M284X-0Z0W1X-531H21-6W2X0F"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
